import { TeamScheduleSectionHeaderSummary , TeamScheduleSectionHeaderSummaryHeight } from "./TeamScheduleHeader/TeamScheduleSectionHeader";

import { useSpaceSize } from "arkh";
import Animated, {
  SharedValue,
  useAnimatedStyle,
} from "react-native-reanimated";
import { Platform, View } from "react-native";
import { TeamScheduleSectionHeaderSummary_teamSchedule$key } from "./TeamScheduleHeader/__generated__/TeamScheduleSectionHeaderSummary_teamSchedule.graphql";

export function TeamScheduleStickyHeaders(props: {
  numberOfButtons: SharedValue<number>;
  onPress(freq: "DAILY" | "MONTHLY" | "WEEKLY"): void;
  backgroundColor: string;
  headers: {
    schedule: TeamScheduleSectionHeaderSummary_teamSchedule$key;
    title: string;
    freq: "DAILY" | "MONTHLY" | "WEEKLY";
  }[];
  extraRightPadding?: number;
}) {
  const padding = useSpaceSize("medium");

  const sharedStyle: any = {
    width: "100%",

    overflow: "hidden",
  };
  const style1 = useAnimatedStyle(() => ({
    overflow: "hidden",
    backgroundColor: "transparent",
    height:
      TeamScheduleSectionHeaderSummaryHeight *
      Math.floor(props.numberOfButtons.value),
  }));

  return (
    <View
      style={{
        position: "absolute",
        left: padding,

        right:
          padding -
          (Platform.OS === "web" ? 0.1 : 0) +
          (props.extraRightPadding ?? 0),
        backgroundColor: props.backgroundColor,
      }}
    >
      <Animated.View style={[sharedStyle, style1]}>
        {props.headers.map((h, i) => (
          <TeamScheduleSectionHeaderSummary
            key={i + ""}
            title={h.title}
            teamSchedule={h.schedule}
            onPress={() => {
              props.onPress(h.freq);
            }}
            index={i + 2}
            stickyIndex={props.numberOfButtons}
          />
        ))}
      </Animated.View>
    </View>
  );
}
